import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FormHelperModule } from '../form/form-hepler.module';
import { ImageUploadModule } from '../shared.module';
import { InfoMapComponent } from './info-map/info-map.component';
import { InfoModalComponent } from './info-modal/info-modal.component';
import { PageBreadcrumbComponent } from './page-breadcrumb/page-breadcrumb.component';
import { PageLoaderComponent } from './page-loader/page-loader.component';
import { ModifyHeadInfoComponent } from './tab-head/modify-head-info/modify-head-info.component';
import { TabHeadComponent } from './tab-head/tab-head.component';
import { TabMenuModule } from 'primeng/tabmenu';
import { ButtonModule } from 'primeng/button';
import { PrintDocComponent } from './print-doc/print-doc.component';


@NgModule({
  declarations: [
    InfoMapComponent,
    PageBreadcrumbComponent,
    PageLoaderComponent,
    InfoModalComponent,
    TabHeadComponent,
    ModifyHeadInfoComponent,
    PrintDocComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormHelperModule,
    ImageUploadModule,
    TabMenuModule,
    ButtonModule
  ],
  exports: [InfoMapComponent, PageBreadcrumbComponent, PageLoaderComponent,
    TabHeadComponent, ModifyHeadInfoComponent]
})
export class FeatureModalModule { }
